import moment from 'moment'
export const FormatDate = (date) => {
    const d = new Date(date)
    return `${moment(d).format('DD')}/${moment(d).format('MM')}/${moment(d).format('YYYY')}`
}